import script from "./AddPrescription.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPrescription.vue?vue&type=script&setup=true&lang=js"

import "./AddPrescription.vue?vue&type=style&index=0&id=917923fa&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917923fa"]])

export default __exports__